

<template>
  <div class="content list-list list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">UserInfo</h4>

          <div class="row">
            <div style="width: 100%">
              <div style="column-gap: 5px; text-align: right">
                <base-button type="primary" @click="search">Search</base-button>
                <base-button type="primary" @click="reset">Reset</base-button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <el-table
                :data="tableData"
                style="width: 100%; margin-bottom: 20px"
                row-key="id"
                border
                default-expand-all
              >
                <el-table-column prop="date" label="Department/Teams" sortable />
                <el-table-column prop="name" label="Name" sortable />
                <el-table-column prop="address" label="Address" sortable />
              </el-table>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script setup>
import { watch, ref } from "vue";
import baseInput from "@/components/newUI/Inputs/BaseInput";
import baseButton from "@/components/newUI/BaseButton";
import baseCheckbox from "@/components/newUI/Inputs/BaseCheckbox";
import router from "@/router/index";

const clientType = ref("");
const isNewClient = ref(false);
const newContract = () => {
  router.replace("/test2");
};

const tableData = [
  // {
  //   id: 2,
  //   date: "2016-05-04",
  //   name: "wangxiaohu",
  //   address: "No. 189, Grove St, Los Angeles",
  // },
  {
    id: 3,
    date: "BUS",
    name: "",
    address: "",
    children: [
      {
        id: 31,
        date: "teamA",
      },
      {
        id: 32,
        date: "teamB",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamB",
            name: "a1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamB",
            name: "a2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
       {
        id: 35,
        date: "teamC",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamC",
            name: "C1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamC",
            name: "C2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    date: "BB",
    name: "",
    address: "",
    children: [
      {
        id: 31,
        date: "teamA",
      },
      {
        id: 32,
        date: "teamB",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamB",
            name: "a1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamB",
            name: "a2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
       {
        id: 35,
        date: "teamC",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamC",
            name: "C1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamC",
            name: "C2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    date: "MTR",
    name: "",
    address: "",
    children: [
      {
        id: 31,
        date: "teamA",
      },
      {
        id: 32,
        date: "teamB",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamB",
            name: "a1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamB",
            name: "a2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
       {
        id: 35,
        date: "teamC",
        name: "",
        address: "",
        children: [
          {
            id: 51,
            date: "teamC",
            name: "C1",
            address: "No. 189, Grove St, Los Angeles",
          },
          {
            id: 52,
            date: "teamC",
            name: "C2",
            address: "No. 189, Grove St, Los Angeles",
          },
        ],
      },
    ],
  },
];
</script>


